import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';
import * as constants from '../const/constants';

@Pipe({
  name: 'formatDateNob'
})
export class FormatDateNobPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if (value) {
      return moment(value).format(constants.CONFIGURATION.DEFAULT_DATE_FORMAT);
    }
    return '';
  }

}
